export default {
  state: {
    list: [
      // id должно совпадать с именем переменной модуля, подключаемого в ../store.js
      // для соответствующего типа текстиля
      {
        id: 'tShirts',
        label: 'Футболки',
        printLocations: ['front', 'sleeveLeft', 'sleeveRight', 'back'],
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: {
            onWhite: 1,
            onColor: 1.2,
          },
        },
        packingPrice: 7,
      },
      {
        id: 'polo',
        label: 'Рубашки-поло',
        printLocations: ['front', 'sleeveLeft', 'sleeveRight', 'back'],
        printPriceMultiplier: {
          silkScreen: 1.2,
          fullColor: {
            onWhite: 1.2,
            onColor: 1.4,
          },
        },
        packingPrice: 7,
      },
      {
        id: 'sweatshirts',
        label: 'Свитшоты',
        printLocations: ['front', 'sleeveLeft', 'sleeveRight', 'back'],
        printPriceMultiplier: {
          silkScreen: 1.4,
          fullColor: {
            onWhite: 1,
            onColor: 1,
          },
        },
        packingPrice: 7,
      },
      {
        id: 'hoodies',
        label: 'Худи',
        printLocations: ['front', 'sleeveLeft', 'sleeveRight', 'back', 'frontPocket'],
        printPriceMultiplier: {
          silkScreen: 1.4,
          fullColor: {
            onWhite: 1.3,
            onColor: 1.5,
          },
        },
        packingPrice: 7,
      },
      {
        id: 'baseballCaps',
        label: 'Бейсболки',
        printLocations: ['baseballCapForehead', 'baseballCapTempleLeft', 'baseballCapTempleRight', 'baseballCapBack'],
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: {
            onWhite: 1,
            onColor: 1,
          },
        },
        packingPrice: 7,
      },
      {
        id: 'bags',
        label: 'Пакеты',
        printLocations: ['bagFront', 'bagBack'],
        printPriceMultiplier: {
          bagPrint: 1,
          fullColor: {
            onWhite: 1,
            onColor: 1.4,
          },
        },
        packingPrice: 0,
      },
    ],
  },
  getters: {
    textileTypeLabels: state => {
      let labels = {}
      state.list.forEach(type => {
        labels[type.id] = type.label
      })
      return labels
    }
  },
}